import { useApi } from "utils"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { FormType } from "../../types"

export function useGetAllOpeningStock() {
  const api = useApi()
  const [data, setData] = useState<FormType[]>([])
  const [isLoading, setLoading] = useState(true)

  const fetchingApi = () => api.get("/opening-stock/all-opening-stock")

  const fetchData = () => {
    setLoading(true)

    fetchingApi()
    .then((res: SuccessFetch<{ payload: FormType[]}>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}
